/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unknown-property */
import React from 'react'

import LargeKPI from './large-kpi'
import SmallKPI from './small-kpi'

interface KPIs {
  colorCode: string
  count: string
  link: string
  title: string
}
interface Props {
  filter: any
  mainKPI: KPIs
  sectionCode: number
  setKpiName:any
  smallKPIData: KPIs[]
  updateKpiFilter: (e) => void
}
//SmallContainerKPI AKA Unassigned KPI
const SmallContainerKPI = ({
  filter,
  mainKPI,
  sectionCode,
  setKpiName,
  smallKPIData,
  updateKpiFilter,
}: Props) => {
  const smallKPIs = smallKPIData?.map((kpi: KPIs, key: number) => {
    return (
      <SmallKPI
        filter={filter}
        key={key}
        kpi={kpi}
        sectionCode={sectionCode}
        setKpiName={setKpiName}
        updateKpiFilter={updateKpiFilter}
      />
    )
  })

  return (
    <div className='col col-md-12 align-items-stretch d-flex mt-1'>
      <div className='bordered2 border-radius w-100 p-0'>
        <LargeKPI key={0}kpi={mainKPI} setKpiName={setKpiName} updateKpiFilter={updateKpiFilter}/>
        <div className='col border-top2 whitebg'>
          <div className='mx-1 py-1'>
            <div className='row'>{smallKPIs}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SmallContainerKPI
